export default {
  loyaltyPurchases: {
    isLoading: false,
    data: [],
    count: 0,
    status: null,
    error: false,
    errorMessage: null
  },
};
